module.exports = __webpack_public_path__ + "img/vr_hoehle.05f17dab.jpg";